import styled, { css } from "styled-components";
import { fluid } from "./utils/fluid";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  display: inline;
  padding-bottom: 4px; /* space for underline */
  text-decoration: none;
  white-space: normal;
  color: ${({ theme }) => theme.colors.imperialRed};
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.imperialRed},
    ${({ theme }) => theme.colors.imperialRed}
  );
  background-size: 0% 2px; /* start with 0 width, 2px tall */
  background-repeat: no-repeat;
  background-position: left bottom; /* stick it to the baseline */
  transition: background-size 0.3s ease;
  &:hover {
    background-size: 100% 2px; /* animate width across the text */
  }
`;

export const TypoDisplayStyles = css`
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.display};
  line-height: ${({ theme }) => theme.lineHeight.display};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.display,
      maxSize: theme.fontScale.augmentedFourth.display,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoDisplay = styled.div`
  ${TypoDisplayStyles};
`;

export const TypoHeadingStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.heading};
  line-height: ${({ theme }) => theme.lineHeight.heading};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.heading,
      maxSize: theme.fontScale.augmentedFourth.heading,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoHeading1 = styled.div`
  ${TypoHeadingStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;

export const TypoHeading2 = styled.div`
  ${TypoHeadingStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const TypoSubheadingStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.subheading};
  line-height: ${({ theme }) => theme.lineHeight.subheading};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.subheading,
      maxSize: theme.fontScale.augmentedFourth.subheading,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoSubheading1 = styled.div`
  ${TypoSubheadingStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;

export const TypoSubheading2 = styled.div`
  ${TypoSubheadingStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const TypoTitleStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.title};
  line-height: ${({ theme }) => theme.lineHeight.title};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.title,
      maxSize: theme.fontScale.augmentedFourth.title,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoTitle1 = styled.div`
  ${TypoTitleStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;

export const TypoTitle2 = styled.div`
  ${TypoTitleStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const TypoSubtitleStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.subtitle};
  line-height: ${({ theme }) => theme.lineHeight.subtitle};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.subtitle,
      maxSize: theme.fontScale.augmentedFourth.subtitle,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoSubtitle1 = styled.div`
  ${TypoSubtitleStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;
export const TypoSubtitle2 = styled.div`
  ${TypoSubtitleStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const TypoLabelStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.label};
  line-height: ${({ theme }) => theme.lineHeight.label};
  padding: ${({ theme }) => theme.fontScale.augmentedFourth.label} 0
    calc(${({ theme }) => theme.fontScale.augmentedFourth.label} * 2);
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.label,
      maxSize: theme.fontScale.augmentedFourth.label,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoLabel1 = styled.div`
  ${TypoLabelStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;

export const TypoLabel2 = styled.div`
  ${TypoLabelStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const TypoMenuStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.menu};
  line-height: ${({ theme }) => theme.lineHeight.menu};
  text-transform: uppercase;
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.menu,
      maxSize: theme.fontScale.augmentedFourth.menu,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoMenu1 = styled.div`
  ${TypoMenuStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicmedium};
`;

export const TypoMenu2 = styled(TypoSubtitle1)`
  ${TypoMenuStyles};
  text-transform: capitalize;
`;

export const TypoBodyStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.body};
  color: ${({ theme }) => theme.colors.onyx};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.size, // 1.33333333
      maxSize: theme.fontScale.augmentedFourth.size, // 1.44444444
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoBody1 = styled.p`
  ${TypoBodyStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const TypoBody2 = styled.p`
  ${TypoBodyStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const TypoCaptionStyles = css`
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-size: ${({ theme }) => theme.fontScale.majorSecond.caption};
  letter-spacing: ${({ theme }) => theme.letterSpacing.caption};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.caption, // 1.33333333
      maxSize: theme.fontScale.augmentedFourth.caption, // 1.44444444
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoCaption1 = styled.div`
  ${TypoCaptionStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const TypoCaption2 = styled.div`
  ${TypoCaptionStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const TypoCaption3 = styled.div`
  ${TypoCaptionStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;

export const TypoCaption4 = styled.div`
  ${TypoCaptionStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicmedium};
`;

export const TypoOverlineStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.overline};
  line-height: ${({ theme }) => theme.lineHeight.overline};
  text-transform: uppercase;
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.overline, // 1.33333333
      maxSize: theme.fontScale.augmentedFourth.overline, // 1.44444444
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoOverline1 = styled.div`
  ${TypoOverlineStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
`;

export const TypoOverline2 = styled.div`
  ${TypoOverlineStyles};
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicmedium};
  font-weight: ${({ theme }) => theme.fontWeight.light};
`;

export const TypoFineStyles = css`
  letter-spacing: ${({ theme }) => theme.letterSpacing.fine};
  line-height: ${({ theme }) => theme.lineHeight.fine};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.fine, // 1.33333333
      maxSize: theme.fontScale.augmentedFourth.fine, // 1.44444444
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const TypoFine1 = styled.div`
  ${TypoFineStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const TypoFine2 = styled.div`
  ${TypoFineStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const ParadoxSubtitle = styled(TypoSubtitle1)`
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  padding: clamp(0.5rem, 0.2143rem + 1.1429vw, 1.5rem) 0;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${({ theme }) => theme.colors.phillipineSilver};
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${({ theme }) => theme.colors.phillipineSilver};
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.pageSubtitle.xs,
      maxSize: theme.spacing.pageSubtitle.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
  margin-bottom: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const ModulePin = styled(TypoOverline2)`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.onyx};
  padding: 8px;
  border-radius: 8px;
  width: min-content;
  white-space: nowrap;
`;

export const SectionTitle = styled(TypoTitle1)`
  text-transform: uppercase;
  white-space: nowrap;
  text-align: center;
  color: ${({ theme }) => theme.colors.onyx};
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
    calc(${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} / 2)
  `};
  gap: ${({ theme }) => `
    0
    ${fluid({
      minSize: theme.spacing.sectionTitle.xs,
      maxSize: theme.spacing.sectionTitle.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
  &::selection {
    color: ${({ theme }) => theme.colors.imperialRed};
  }
  &::before,
  &::after {
    content: "";
    display: inline-block;
    align-self: center;
    width: 100%;
    height: 32px; /* total vertical span of the lines */
    background-position: 0 calc(50% - 4px);
    background-image: repeating-linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.onyx} 0,
      ${({ theme }) => theme.colors.onyx} 1px,
      ${({ theme }) => theme.colors.white} 1px,
      ${({ theme }) => theme.colors.white} 8px
    );
  }
`;

export const SectionTitleStroke = styled(TypoTitle1)`
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.onyx};
  -webkit-text-fill-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  position: absolute;
  z-index: -1;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    top: 2px;
    left: -2px;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    top: 2.5px;
    left: -2.5px;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    top: 3px;
    left: -3px;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    top: 3.5px;
    left: -3.5px;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    top: 4px;
    left: -4px;
  }
`;

// MDX Styles
export const H1 = styled(TypoDisplay)``;

export const H2 = styled(TypoTitle1)`
  position: relative;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
    calc(${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} / 2)
  `};
  &::before {
    content: "";
    position: absolute;
    top: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })};
    left: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.imperialRed};
    width: 100px;
    height: 1px;
    margin: 0;
  }
`;

export const H3 = styled(TypoSubtitle2)``;

export const H4 = styled(TypoLabel1)``;

export const H5 = styled(TypoLabel2)``;

export const H6 = styled(TypoBody1)``;

export const Blockquote = styled.blockquote`
  margin: 0 0 24px;
  position: relative;
  z-index: 0;
  border: 1px solid ${({ theme }) => theme.colors.imperialRed};
  border-radius: 0 32px 32px 32px;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    calc(${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} * 3)
  `};
  &::before {
    ${TypoDisplayStyles};
    content: '"';
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicmedium};
    color: ${({ theme }) => theme.colors.imperialRed};
    padding: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      ${fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      0
    `};
  }
  p {
    ${TypoLabel2};
    color: ${({ theme }) => theme.colors.taupeGrey};
    position: relative;
  }
`;

export const Ul = styled.ul`
  ${TypoBodyStyles};
  position: relative;
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  margin-bottom: ${({ theme }) => `
    calc(${fluid({
      minSize: theme.fontScale.majorSecond.size,
      maxSize: theme.fontScale.augmentedFourth.size,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} * 2)
  `};
  list-style-type: square;
  li {
    margin-bottom: ${({ theme }) =>
      fluid({
        minSize: theme.fontScale.majorSecond.size,
        maxSize: theme.fontScale.augmentedFourth.size,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })};
    &:last-child {
      margin-bottom: 0;
    }
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    width: 100px;
  }
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    width: 100px;
  }
`;

export const Ol = styled(Ul)`
  list-style-type: decimal;
`;

export const P = styled.p`
  ${TypoBodyStyles};
  font-family: ${({ theme }) => theme.fontFace.maitree};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const Strong = styled(TypoBody1)``;
